import React from "react";
import { endpoint } from "./../../common/constant/endpoints/index";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import { SUPPLEMENTARY_ID_FLAG } from "../studentSerach/StudentList";
import { getFormattedDate } from "./batch-search";
import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";

export const getIdsArray = (dropdownList) => {
  let result = [];
  if (Array.isArray(dropdownList)) {
    result = dropdownList.map((item) => item.value);
  }
  return result;
};

export const getByLabelIDMapping = (selected = [], dropdownsValues = []) => {
  const labels = [];
  dropdownsValues.map((item) => {
    if (selected.includes(item.value)) labels.push(item);
  });
  return labels;
};
export const getDataSetMap = (items) => {
  let result = {};
  items.map((item) => (result[item.value] = item.label));
  return result;
};

export const BACK_ICON_STYLE = {
  color: "#0F0F0F",
  height: "1.2rem",
  width: "1.4rem",
  cursor: "pointer",
  marginRight: ".5rem",
};

const getDropdownIds = (items) => items.map((item) => item.value);

// if request any key contain array of object{label:"", value:""} then it will update array of ids
export const updateRequest = (request) => {
  let temp = { ...request };
  for (const key in request) {
    if (
      Array.isArray(request[key]) &&
      request[key].length > 0 &&
      request[key][0]?.label
    ) {
      const result = getDropdownIds(request[key]);
      temp[key] = Array.isArray(result) ? result.flat(Infinity) : result;
    }
    if (request[key]?.label) {
      temp[key] = request[key]["value"];
    }
  }
  return temp;
};

export const dropdownMapping = async (url, displayLabel) => {
  const responseData = await fetchAllPromisedData(url, false);
  if (Array.isArray(responseData)) {
    const result = responseData?.map((o) => {
      return { label: o[displayLabel], value: o["id"] };
    });
    return result;
  } else return [];
};

export const getBusinessAreaAndRegionDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(
      `${endpoint.businessArea.getAllActiveV2}`,
      "businessAreaDispValue"
    ),
    dropdownMapping(`${endpoint.region.getAllActive}`, "regionDispValue"),
  ]);
  return {
    businessAreas: p[0],
    regions: p[1],
  };
};

export const programActionDropdown = [
  { label: "APPL", value: "APPL" },
  { label: "BTCG", value: "BTCG" },
  { label: "CRCG", value: "CRCG" },
  { label: "DISA", value: "DISA" },
  { label: "DISC", value: "DISC" },
  { label: "FOLO", value: "FOLO" },
  { label: "IBTR", value: "IBTR" },
  { label: "MATR", value: "MATR" },
  { label: "RADM", value: "RADM" },
  { label: "STCG", value: "STCG" },
  ...(SUPPLEMENTARY_ID_FLAG ? [{ label: "MLBA", value: "MLBA" }] : []),
];

export const classDropdown = [
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
];

export const allocationStatusDropdown = [
  { label: "Allocated", value: "ALLOCATE" },
  { label: "Unallocated", value: "DEALLOCATE" },
];

export const getDownloadFileUrl = async (key) => {
  const templateUrl = await fetchAllPostPromisedData(
    `${endpoint.fetchS3Url.getDownloadUrl}?key=${key}`,
    {}
  );
  if (templateUrl?.code === 200 && templateUrl?.data) {
    window.open(`${templateUrl?.data?.url}`);
  } else {
    failureToast("Something went wrong please try after sometime.");
  }
};

const ShowDetails = ({ details }) => {
  return (
<div>
  <div className="d-flex gap-2">
    <span
      className="semi-bold text-dark d-inline-block"
      style={{ width: "90px", minWidth: "90px" }}
    >
      Start date:
    </span>
    <span>{getFormattedDate(details?.courseStartDate)}</span>
  </div>

  <div className="d-flex gap-2">
    <span
      className="semi-bold text-dark d-inline-block"
      style={{ width: "90px", minWidth: "90px" }}
    >
      End date:
    </span>
    <span>{getFormattedDate(details?.courseEndDate)}</span>
  </div>

  <div className="d-flex gap-2">
    <span
      className="semi-bold text-dark d-inline-block"
      style={{ width: "90px", minWidth: "90px" }}
    >
      Description:
    </span>
    <span>{details?.courseDescription}</span>
  </div>
</div>
  );
};
export const getCourseIdDetailIcon = (
courseIdDetail,
) => {
  

    return (
      <CustomTooltip
        showOnClick={true}
        title={<ShowDetails details={courseIdDetail} />}
      >
        <div className="ellipsis-text-container">
          <span
            className="ms-2 cursor-pointer"
            style={{ color: "#0d6efd" }}
            title="View Action History"
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </span>
        </div>
      </CustomTooltip>
    );


};
